<template>
    <div>
        <hero></hero>
        <div>
          <b-card no-body class="overflow-hidden" style="max-width: 100%;">
            <b-row no-gutters>
              <b-col md="12">
                <!-- <b-card-img
                  src="img/materias.jpg"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img> -->
                <video-embed src="https://www.youtube.com/watch?v=KLJSUdt3rrU"></video-embed>
              </b-col>
              <!-- <b-col md="12" class="text-center">
                <em> <b> Para mayor información, contáctanos.</b></em>
                <b-row class="text-center">
                  <b-col md="12">
                    <b-card-body title="Costos por materias">
                      <b-card-group deck>
                        <b-card
                          header="Estudiantes dentro de Venezuela"
                          header-tag="header"
                        >
                          <b-card-text>Matrícula con subsidio.</b-card-text>
                        </b-card>

                        <b-card
                          header="Estudiantes fuera de Venezuela"
                          header-tag="header"
                        >
                          <b-card-text> Matrícula completa.</b-card-text>
                        </b-card>
                      </b-card-group>
                    </b-card-body>
                  </b-col>
                  <b-col md="12" class="text-center">
                  <em> <b> Para mayor información, contáctanos.</b></em>
                  <b-col md="6" >
                      Elisa Mejías. <br>
                      <b>Coordinadora de Admisión.</b>
                  </b-col>
                  <b-col md="6">
                    <b-icon icon="telephone" tel="+584128780967"></b-icon> +584128780967 <br>
                    <b-icon icon="inbox"></b-icon> admision@ibldvenezuela.com
                  </b-col>
                  </b-col>
                  
                </b-row>
              </b-col>
              <b-col md="6" class="text-center">
                Elisa Mejías. <br>
                <b>Coordinadora de Admisión.</b>
              </b-col>
              <b-col md="6" class="text-center">
                <b-icon icon="telephone" tel="+584128780967"></b-icon> +584128780967 <br>
                    <b-icon icon="inbox"></b-icon> admision@ibldvenezuela.com
              </b-col> -->
            </b-row>
          </b-card>
        </div>
        
        <inscripciones-nuevas></inscripciones-nuevas>
        <div class="text-center">
        <br>
        <br>
        <h3>Puedes descargar nuestro pensum en el siguiente enlace:</h3>
        <a target="_blank" href="https://api.sistema.ibldvenezuela.com/storage/documentos/pensum-academico.pdf" class="h2 mb-2">Descargar <b-icon icon="download"></b-icon></a>
        
      </div>
        <div>
          <b-card no-body class="overflow-hidden" style="max-width: 100%;">
            <b-row no-gutters>            
              <b-col md="12" class="text-center">
                <em> <b> Para mayor información, contáctanos.</b></em>
              </b-col>
              <b-col md="6" class="text-center">
                Elisa Mejías. <br>
                <b>Coordinadora de Admisión.</b>
              </b-col>
              <b-col md="6" class="text-center">
                <b-icon icon="telephone" tel="+584128780967"></b-icon> +584128780967 <br>
                    <b-icon icon="inbox"></b-icon> admision@ibldvenezuela.com
              </b-col>
            </b-row>
          </b-card>
        </div>

        
      
    </div>
</template>
<script>
import Hero from "./principal/Hero";
import InscripcionesNuevas from "./principal/NuevasInscripciones"

export default {
  name: "components",
  components: {
    Hero,
    InscripcionesNuevas
  }
};
</script>
